import * as React from 'react';
export const beobankSvg = React.forwardRef(function beobankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#572380',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E20613',
        d: 'M15.95 27.55c-6.4 0-11.6-5.2-11.6-11.6A11.61 11.61 0 0 1 18.23 4.57a1.7 1.7 0 1 1-.67 3.33 8.21 8.21 0 1 0-1.61 16.25 8.21 8.21 0 0 0 7.57-11.37 1.7 1.7 0 1 1 3.13-1.31 11.61 11.61 0 0 1-10.7 16.08',
      }),
    ),
  );
});
beobankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var beobank = {
  category: 'brand',
  colorable: false,
  name: 'beobank',
  svg: beobankSvg,
};
